var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6391",
    "data-name": "Group 6391",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18263",
    "data-name": "Path 18263",
    d: "M50,21.2H2V42.8A7.2,7.2,0,0,0,9.2,50H42.8A7.2,7.2,0,0,0,50,42.8ZM14,16.4A2.4,2.4,0,0,1,11.6,14V4.4a2.4,2.4,0,1,1,4.8,0V14A2.4,2.4,0,0,1,14,16.4Zm24,0A2.4,2.4,0,0,1,35.6,14V4.4a2.4,2.4,0,0,1,4.8,0V14A2.4,2.4,0,0,1,38,16.4Z",
    fill: "#b5a1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18264",
    "data-name": "Path 18264",
    d: "M42.8,4H40.4v7.2a2.4,2.4,0,0,1-4.8,0V4H16.4v7.2a2.4,2.4,0,1,1-4.8,0V4H9.2A7.2,7.2,0,0,0,2,11.2v7.2H50V11.2A7.2,7.2,0,0,0,42.8,4Z",
    transform: "translate(0 2.8)",
    fill: "#6d44e5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.f888df4232f7434afc1ff113dee6e0b2.svg";
export { ForwardRef as ReactComponent };